/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import LetOnly_Section1 from "./sections/LetOnly_Section1";
import LetOnly_Section2 from "./sections/LetOnly_Section2";

function LetOnlyManagement() {
  usePageMeta({
    title: "Let Only Property Management Ireland | Spechs",
    description:
      "Let-only property management services across Ireland. We find and place tenants while you retain control.",
    canonical: "https://www.spechs.ie/property/let-only/",
  });
  return (
    <SubPageLayout title="‘Let Only’ Property Management">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <LetOnly_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <LetOnly_Section2 />
      </MKBox>
    </SubPageLayout>
  );
}

export default LetOnlyManagement;
